const handleDeleteQuestionModalEquipService = {
  confirm: '¿Realmente desea eliminar la pregunta?',
  title: 'ELIMINAR PREGUNTA DE LA CHECKLIST'
};

export default handleDeleteQuestionModalEquipService;
